import { InputHTMLAttributes } from "react";

import Input from "./Input";

export default function TextInput(props: TextInputProps) {
    const { onChange, ...restProps } = props;
    return (
        <Input
            onChange={ (event) => onChange(event.target.value) }
            type="text"
            { ...restProps }
        />
    );
}

interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
    onChange: (value: string) => unknown
}
